module.exports = __webpack_public_path__ + "static/rittal_logo-1328177f1f7da6c820fae08c5a25140b.png";